/* The playback scrubber: a bar the user can drag, with a knob that grows on
   hover so it stays a thin line at rest. */

.scrub {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 9px;
  touch-action: none;
  cursor: pointer;
}

.time {
  font-size: 11px;
  font-weight: 550;
  color: var(--ink-3);
  font-variant-numeric: tabular-nums;
  min-width: 34px;
}

.duration {
  text-align: right;
}

.bar {
  position: relative;
  height: 6px;
  border-radius: 999px;
  background: rgba(11, 31, 23, 0.1);
  box-shadow: inset 0 1px 1px rgba(11, 31, 23, 0.06);
}

.fill {
  position: absolute;
  inset: 0 auto 0 0;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--accent-deep), var(--accent));
  box-shadow: 0 0 10px var(--accent-glow);
  transition: width 0.1s linear;
}

.knob {
  position: absolute;
  top: 50%;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  transform: translate(-50%, -50%) scale(0.62);
  box-shadow:
    0 1px 4px rgba(16, 48, 34, 0.28),
    0 0 0 0.5px rgba(11, 31, 23, 0.06);
  transition:
    transform 0.22s var(--ease),
    left 0.1s linear;
}

/* While dragging, the fill and knob follow the finger rather than easing
   to it — and the knob stays at full size, as it does on hover. */
.dragging .fill {
  transition: none;
}

.dragging .knob {
  transform: translate(-50%, -50%) scale(1);
  transition: transform 0.22s var(--ease);
}

.scrub:hover .knob {
  transform: translate(-50%, -50%) scale(1);
}

@media (max-width: 620px) {
  .time {
    min-width: 30px;
    font-size: 10.5px;
  }
}
